import React from 'react';
import PropTypes from 'prop-types';
import Link from './shared/Link';
import utils from '../../../common/utils';
import fabric from '../../../common/fabric';

/**
 * Rectangle component
 *
 * @param props
 * @returns {XML}
 * @constructor
 */
const Rectangle = props => {
  const { hyperlink, matrixGroup, globalScale } = props;
  const [params, setParams] = React.useState(props.params);
  React.useEffect(() => {
    setParams(props.params);
  }, [props]);

  const { shadow } = params;
  const [svgRendered, setSvgRendered] = React.useState(null);
  const [bounds, setBounds] = React.useState(null);
  const transformMatrix = props.matrixGroup
    ? fabric.util.multiplyTransformMatrices(
        matrixGroup,
        params.ludus.transformMatrix,
      )
    : params.ludus.transformMatrix;

  const slideTransform = fabric.util.multiplyTransformMatrices(
    [globalScale, 0, 0, globalScale, 0, 0],
    [1, 0, 0, 1, transformMatrix[4], transformMatrix[5]],
  );

  React.useEffect(() => {
    const options = fabric.util.qrDecompose(transformMatrix);
    const object = new fabric.LudusRect({
      ...params,
      ludus: { ...params.ludus, transformMatrix },
      shadow: null,
    });

    object.setOptions(options);
    const _bounds = object.getBoundingRect();
    _bounds.width = _bounds.width.toFixed(2);
    _bounds.height = _bounds.height.toFixed(2);
    setBounds(_bounds);
    object.setPositionByOrigin(
      { x: _bounds.width / 2, y: _bounds.height / 2 },
      'center',
      'center',
    );

    const _svgRendered = `<svg width="${_bounds.width}px" height="${
      _bounds.height
    }px"
  fill="none" xmlns="http://www.w3.org/2000/svg" style="overflow:hidden">${object.toSVG()}</svg>`;
    setSvgRendered(_svgRendered);
  }, [params]);

  if (!svgRendered || !bounds) {
    return null;
  }

  const blockStyles = {
    ...props.style,
    top: 0,
    left: 0,
    width: `${bounds.width}px`,
    height: `${bounds.height}px`,
    mixBlendMode:
      props.params.globalCompositeOperation === 'source-over'
        ? 'normal'
        : props.params.globalCompositeOperation,
    filter: shadow
      ? utils.getDropShadowCSSFilterFromFabricShadow(shadow, 0, 1)
      : 'none',
    transform: `${
      utils.isSafari && shadow ? 'translateZ(0px)' : ''
    } translate(-50%, -50%) matrix(${[...slideTransform]})`,
  };

  return (
    <Link
      hyperlink={hyperlink}
      style={blockStyles}
      dangerouslySetInnerHTML={{ __html: svgRendered }}
    />
  );
};
Rectangle.propTypes = {
  style: PropTypes.objectOf(
    PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  ).isRequired,
  params: PropTypes.objectOf(
    PropTypes.oneOfType([
      PropTypes.array,
      PropTypes.bool,
      PropTypes.func,
      PropTypes.number,
      PropTypes.object,
      PropTypes.string,
    ]),
  ).isRequired,
  hyperlink: PropTypes.string,
  matrixGroup: PropTypes.arrayOf(PropTypes.number),
  globalScale: PropTypes.number,
};
Rectangle.defaultProps = {
  hyperlink: null,
  matrixGroup: null,
  globalScale: 1,
};

export default Rectangle;
